import React from "react";
import { connect } from "react-redux";
import { searchPurchaseItemReport } from "../../../actions/purchase";
import { Table } from "antd";

const RenderTable = ({
    details,
    pageno,
    page_size,
    setreload,
    reload,
    setloading,
    total_data,
    searchPurchaseItemReport,
}) => {
    var formatter = new Intl.NumberFormat("en-IN");

    const columns = [
        {
            title: "SL",
            dataIndex: "id",
            key: "id",
            render: (text, record, index) => {
                return (pageno.current - 1) * page_size.current + index + 1;
            },
        },
        {
            title: "Date",
            dataIndex: "purchase_date",
            key: "purchase_date",
        },
        {
            title: "PO No.",
            dataIndex: "purchase_number",
            key: "purchase_number",
        },
        {
            title: "Item Code",
            dataIndex: "Item",
            key: "Item",
        },
        // {
        //     title: "Item Title",
        //     dataIndex: "item_title",
        //     key: "item_title",
        // },
        {
            title: "Size",
            dataIndex: "size",
            key: "size",
        },
        {
            title: "Category",
            dataIndex: "category",
            key: "category",
        },
        {
            title: "Brand",
            dataIndex: "brand",
            key: "brand",
        },
        // {
        //     title: "Supplier",
        //     dataIndex: "supplier_name",
        //     key: "supplier_name",
        // },
        {
            title: "Location",
            dataIndex: "location_name",
            key: "location_name",
        },
        {
            title: "Qty",
            dataIndex: "quantity",
            key: "quantity",
            render: (text) => formatter.format(text),
        },
        // {
        //     title: "Purchase Price",
        //     dataIndex: "purchase_price",
        //     key: "purchase_price",
        //     render: (text) => formatter.format(text),
        // },
        // {
        //     title: "Selling Price",
        //     dataIndex: "selling_price",
        //     key: "selling_price",
        //     render: (text) => formatter.format(text),
        // },
        // {
        //     title: "Total Purchase",
        //     key: "total_purchase",
        //     render: (text, record) => {
        //         const total = record.quantity * record.purchase_price;
        //         return formatter.format(total.toFixed(2));
        //     },
        // },
        // {
        //     title: "Total Selling",
        //     key: "total_selling",
        //     render: (text, record) => {
        //         const total = record.quantity * record.selling_price;
        //         return formatter.format(total.toFixed(2));
        //     },
        // },
    ];

    const handleTableChange = (pagination) => {
        setloading(true);
        pageno.current = pagination.current;
        page_size.current = pagination.pageSize;
        setreload(!reload);
    };

    return (
        <>
            <Table
                columns={columns}
                dataSource={details.results}
                rowKey="id"
                pagination={{
                    current: pageno.current,
                    pageSize: page_size.current,
                    total: details.count,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "50", "100"],
                }}
                onChange={handleTableChange}
                // scroll={{ x: 1500 }}
                summary={() => (
                    <Table.Summary fixed>
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={8}>
                                <b>Current Page Total:</b>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={10}>
                                <b>{formatter.format(total_data.current["current_page_quantity"])}</b>
                            </Table.Summary.Cell>
                            {/* <Table.Summary.Cell index={11}>
                                <b>{formatter.format(total_data.current["current_page_purchase_price"])}</b>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={12}>
                                <b>{formatter.format(total_data.current["current_page_selling_price"])}</b>
                            </Table.Summary.Cell> */}
                            {/* <Table.Summary.Cell index={13} colSpan={2}></Table.Summary.Cell> */}
                        </Table.Summary.Row>
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={8}>
                                <b>Grand Total:</b>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={10}>
                                <b>{formatter.format(total_data.current["total_quantity"])}</b>
                            </Table.Summary.Cell>
                            {/* <Table.Summary.Cell index={11}>
                                <b>{formatter.format(total_data.current["total_purchase_price"])}</b>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={12}>
                                <b>{formatter.format(total_data.current["total_selling_price"])}</b>
                            </Table.Summary.Cell> */}
                            {/* <Table.Summary.Cell index={13} colSpan={2}></Table.Summary.Cell> */}
                        </Table.Summary.Row>
                    </Table.Summary>
                )}
            />
        </>
    );
};

export default connect(null, {
    searchPurchaseItemReport,
})(RenderTable);
